import React from 'react'
import { Link } from 'react-router-dom';
import styled from 'styled-components'
import materialInfo from '../Data'

const Dropdown = ({ onMouseLeave }) => {
  return (
    <DropdownContainer onMouseLeave={onMouseLeave}>
      {materialInfo.map((data, index) => (
        <DropdownItem key={index}>
          <Link to={data.link}>
            <ItemCode>{data.name}</ItemCode>
            <ItemFull>{data.fullform}</ItemFull>
          </Link>
        </DropdownItem>
      ))}
    </DropdownContainer>
  )
}

const DropdownContainer = styled.div`
  background: var(--color-surface);
  width: 240px;
  border: 1px solid var(--color-border);
  border-radius: 6px;
  padding: 6px;
  position: absolute;
  top: calc(100% + 10px);
  left: 0;
  z-index: 200;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08), 0 1px 4px rgba(0, 0, 0, 0.04);
`

const DropdownItem = styled.div`
  border-radius: 4px;
  transition: var(--transition);

  &:not(:last-child) {
    border-bottom: 1px solid var(--color-border);
  }

  &:hover {
    background: var(--color-bg-subtle);
  }

  a {
    text-decoration: none;
    display: block;
    padding: 11px 14px;
  }
`

const ItemCode = styled.span`
  display: block;
  font-size: 13px;
  font-weight: 700;
  color: var(--color-dark);
  letter-spacing: 0.3px;
`

const ItemFull = styled.span`
  display: block;
  font-size: 11px;
  font-weight: 400;
  color: var(--color-muted);
  margin-top: 2px;
  letter-spacing: 0.1px;
`

export default Dropdown
